// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"59ddc87e","146":"942660c8","255":"20a1770f","388":"62d6eb57","957":"95fd7574","978":"81c8fddf"}[chunkId] + ".chunk.css";
};